var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOccupied({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0517 33.8977L20.0517 33.8978C12.6018 33.8977 6.54922 27.676 6.54922 20.0868C6.54922 12.4975 12.6013 6.31114 20.017 6.34624H20.0175C22.751 6.34624 25.348 7.18473 27.6044 8.75772C28.041 9.07714 28.136 9.65037 27.8547 10.1002C27.542 10.546 26.9847 10.6407 26.548 10.3546C24.6371 9.00479 22.3789 8.29462 20.0175 8.29462C13.6237 8.29462 8.41548 13.6242 8.41548 20.1573C8.41548 26.6905 13.6237 32.02 20.0175 32.02C26.4113 32.02 31.6195 26.6905 31.6195 20.1573C31.6195 19.3067 31.5502 18.4542 31.3762 17.6359L31.3758 17.6343C31.2503 17.0893 31.5954 16.5818 32.0892 16.4871L32.0892 16.4872L32.0938 16.4861C32.621 16.3591 33.1183 16.7073 33.2117 17.2169L33.2117 17.2169L33.2124 17.2201C33.4174 18.1638 33.52 19.1427 33.52 20.1219C33.52 27.711 27.4673 33.8977 20.0517 33.8977Z",
    fill: "#613ED2",
    stroke: "white",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0393 7.44013C35.2589 7.2492 35.4585 7.0764 35.6362 6.92293C35.2549 7.38991 34.7639 8 34.1913 8.71704C32.961 10.2576 31.353 12.2927 29.644 14.4653C26.226 18.8104 22.4034 23.7058 20.3887 26.2944L20.388 26.2953C19.7048 27.1936 18.3722 27.1936 17.6889 26.2953L17.6884 26.2946L11.7566 18.6248L11.9887 18.4401C11.9888 18.44 11.9889 18.4399 11.989 18.4398C13.1171 17.5579 14.7065 17.728 15.6016 18.8804C15.6016 18.8804 15.6016 18.8805 15.6017 18.8805L18.0119 22.0145L18.0124 22.0152C18.4565 22.5827 19.2362 22.6303 19.7283 22.1141L19.7288 22.1139L19.7492 22.0917C23.5172 17.992 27.7332 13.997 31.008 11.0221C32.6452 9.53473 34.0469 8.3026 35.0393 7.44013Z",
    fill: "#613ED2",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccupied);
export default __webpack_public_path__ + "static/media/occupied.f805760a4679471936e63f64e6f37461.svg";
export { ForwardRef as ReactComponent };